import React from "react";
import "../../styles/CustomTableLoader.css";

const CustomTableLoader: React.FC = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px 0", marginTop:'6%' }}>
      <div className="loader" />
      <div style={{  color: "#1890ff", fontSize: 14 }}>
        Loading data...
      </div>
    </div>
  );
};

export default CustomTableLoader;
